// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  FormSection,
} from '@vroskus/library-components';

// Helpers
import {
  cleanFormValues,
  isDiff,
} from '@vroskus/library-helpers/dist/browser';
import {
  getPreviousRegionSeasonId,
} from 'common.helpers/dist/browser';
import {
  defaultGetData,
  defaultUpsertItem,
} from '../../../../helpers';

// Components
import ChampionshipFields from '../../../fields/ChampionshipFields';

// Services
import Services from '../../../../services';

// Types
import type {
  $ReducerState,
} from '../../../../redux';

export type $OwnProps = $Translate & {
  id: string;
  item: $Model<'Championship'>;
};

export type $StateProps = {
  main: $ReducerState<'main'>;
};

export type $DispatchProps = Record<string, unknown>;

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  changed: boolean;
  referenceData: Array<$Model<'Championship'>>;
  value: $Model<'Championship'>;
};

class ChampionshipSettingsSectionView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      changed: false,
      referenceData: [],
      value: props.item,
    };
  }

  componentDidMount(): void {
    this.getReferenceData();
  }

  componentDidUpdate(prevProps: $Props): void {
    const {
      item,
    } = this.props;

    if (isDiff(
      prevProps.item,
      item,
    )) {
      this.getReferenceData();
    }
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getReferenceData(): Promise<void> {
    const {
      item,
      main,
    } = this.props;

    const {
      RegionSeasonId,
    } = item;

    await defaultGetData({
      action: async () => {
        const previousRegionSeasonId = getPreviousRegionSeasonId({
          regions: main.regions,
          RegionSeasonId,
        });
        const referenceData = previousRegionSeasonId ? await Services.Api.getResourceChampionship({
          RegionSeasonId: previousRegionSeasonId,
        }) : [];

        await this.setStateAsync({
          referenceData,
        });
      },
    });
  }

  render() {
    const {
      id,
      item,
      t,
    } = this.props;
    const {
      changed,
      referenceData,
      value,
    } = this.state;

    return (
      <FormSection
        changed={changed}
        fields={(
          <ChampionshipFields
            item={value}
            onChange={() => this.setState({
              changed: true,
            })}
            referenceData={referenceData}
          />
        )}
        headerIconClass={'icon-settings'}
        headerTitle={t('Championship settings')}
        id={id}
        labelClearButton={t('Clear')}
        labelSaveButton={t('Save')}
        onAction={(values) => defaultUpsertItem({
          action: async () => {
            const params = cleanFormValues<$Model<'Championship'>>({
              ...value,
              ...values,
            });

            await Services.Api.upsertChampionship(params);

            this.setState({
              changed: false,
            });
          },
        })}
        onClear={() => this.setState({
          changed: false,
          value: item,
        })}
      />
    );
  }
}

export default ChampionshipSettingsSectionView;
